import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  InputBox,
  Tooltip,
  Popconfirm,
} from "../components/Elements/appUtils";
import PageHeader from "../components/Elements/pageHeader";
import { useNavigate } from "react-router-dom";
import axios, { all } from "axios";
import { apiUrl } from "../setting";
import moment from "moment";
import { generateSales } from "./transfer/actions";
import { getToken } from "../request";
import { showLoader, hideLoader } from "../actions/loader";
import { useDispatch } from "react-redux";
import { notification } from "../components/Elements/appUtils";
import { getSaleByBranch } from "./transfer/api";
import { getItemLocalstorage } from "../components/_utils/_utils";
import { approveRequestROIURl } from "./transfer/api";
function ConvertROI() {
  let tableRef = useRef();
  const branchIds = getItemLocalstorage("user")["_id"];
  const userType = getItemLocalstorage("user")["userType"];


  const navigate = useNavigate();
  const currentDate = moment();
  const initialHandleDate = currentDate.format("MM-YYYY");
  const dispatch = useDispatch();
  const [handleDate, setHandleDate] = useState(initialHandleDate);
  const [allList, setAllList] = useState([]);
  const handleSearch = () => {
    

    apiRequest(handleDate);
  };

  const apiRequest = async () => {
    return new Promise(async (resolve) => {
      try {
        const data = await axios.get(getSaleByBranch(), {
          params: {
            dateString: handleDate,
          },
          ...(await getToken()),
        });
      
       
          setAllList(data.data);
          resolve(data.data);
    
      } catch (error) {
        console.error("Error getting the data:", error);
      }
    });
  };

 
  useEffect(() => {
    apiRequest(handleDate);
  }, []);

  useEffect(() => {
    handleSearch(); 
  }, []);

  const approveRequestROI = async (e,saleId) => {
  
    
    e.preventDefault();
    try {
      let config = {
        ...(await getToken()),
      };
      dispatch(showLoader());
      const data = await axios.get(approveRequestROIURl(saleId), config);
     
      dispatch(hideLoader());
      if(data.data.success){
        window.location.reload()
        notification.success({
          message: data.data.message,
      });
      }
      else{
        notification.error({
          message:  data.data.message,
      });
      }
    } catch (error) {
      notification.error({
        message: error,
    });
    }
  };

  const columns = [
    {
      title: "Branch Name",
      dataIndex: "branchName",
      key: "branchName",
      
      render: (text, record) => <>{record.customerId.name}</>,
  
    },
    {
      title: "Total Sale",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (text, record) => <>₹ {record.totalAmount}</>,
    },
    {
      title: "Royalty",
      dataIndex: "royaltyPercentage",
      key: "royaltyPercentage",
      render: (text, record) => <> {record.royalty} %</>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => <> {record.status}</>,
    },
   
    {
      title: "Actions",
      dataIndex: "description",
      key: "description",

      render: (text, record) => (
        <>
          {userType == "branch" && record.status != "done" ? (
            <button
              className="btn btn-success btn-xs"
              onClick={(e) => {
                approveRequestROI(e,record._id);
              }}
            >
              Approve
            </button>
          ) : null}
         
        </>
      ),
    },
  ];

  return (
    <>
      <PageHeader title={"ROI"}>
        <div className="card">
          <div className="card-body">
          
            {/* <button className="btn btn-info btn-sm"onClick={handleSearch}>Search</button> */}
            <Table apiRequest={apiRequest} columns={columns} ref={tableRef} />

       
          </div>
        </div>
      </PageHeader>
    </>
  );
}

export default ConvertROI;
